import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// todo move to noddi-util -.-

// Clsx for conditional classes, will result in possible duplication of classes
// To merge duplication "intelligently" use twMerge('px-2 py-1', 'p-3') => p-3
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
